import { ApiNames } from "components/Common/ApiManagement/apiServices";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../store/actions";
import { handleErrors, showToaster } from "components/Common/common";
import { PAGEPATHS, USERTYPES } from "components/Common/Constant";
import { useEffect, useState } from "react";

const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;

const LinkedInLoginComp = () => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* ---------------------------------------------------
     LISTEN CODE FROM POPUP
  --------------------------------------------------- */
  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === "LINKEDIN_LOGIN_CODE") {
        try {
          setIsLoading(true);

          const { data } = await axiosInstance.post(
            ApiNames.LINKEDIN_AUTH,
            { code: event.data.code, mode: "login" }   // 🔥 login only
          );

          if (data.status === 1) {
            dispatch(getUser(data.data));
            showToaster(1, data.message);

            data.data.userType === USERTYPES.Admin
              ? navigate(PAGEPATHS.Scanlist)
              : navigate(PAGEPATHS.StartAScan);

          } else {
            showToaster(0, data.message);
          }

        } catch (err) {
          handleErrors(err);
        } finally {
          setIsLoading(false);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  /* ---------------------------------------------------
     REDIRECT TO LINKEDIN
  --------------------------------------------------- */
  const loginWithLinkedIn = () => {
    const redirectUri = `${window.location.origin}/oauth/linkedin/callback`;

    const linkedInUrl =
      `https://www.linkedin.com/oauth/v2/authorization` +
      `?response_type=code` +
      `&client_id=${LINKEDIN_CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&scope=openid%20profile%20email`;

    window.open(
      linkedInUrl,
      "linkedinLogin",
      "width=600,height=700"
    );
  };

  return (
    <div style={{ placeSelf: "center", width: "92%" }}>

      <button
        disabled={isLoading}
        className={`login-w-g ${isLoading && "pe-none"}`}
        onClick={loginWithLinkedIn}
        style={{ background: "#0a66c2", color: "#fff" }}
      >
        <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="white"
  >
    <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0.22 8h4.56v16H0.22V8zM8.1 8h4.37v2.16h.06c.61-1.15 2.11-2.37 4.34-2.37 4.64 0 5.5 3.05 5.5 7.01V24h-4.56v-7.96c0-1.9-.03-4.34-2.64-4.34-2.64 0-3.04 2.06-3.04 4.2V24H8.1V8z" />
  </svg>
        <span>Sign in with LinkedIn</span>
      </button>
    </div>
  );
};

export default LinkedInLoginComp;
